/**
 * 数值类型格式化
 */
export const foo = 'foo';

export const numberFormat = (input, length = 4) => {
  const number = Number.parseFloat(input);
  if (Number.isNaN(number)) return '0';
  const base = 10 ** (length + 1);
  return ((number * base) / base).toFixed(length);
};
